/**
 * Extended Error type for job mutation errors
 * Includes validation errors and error metadata from GraphQL mutations
 */
export interface JobMutationError extends Error {
  validationErrors?: Array<{ field: string; message: string }>;
  errorType?: number | string;
  statusCode?: number | string;
  errorMessage?: string;
}

/**
 * Creates a JobMutationError from error data returned by GraphQL mutations
 * @param errorData - Error data from GraphQL mutation response
 * @param defaultMessage - Default error message if errorData.errorMessage is not available
 * @returns JobMutationError instance
 */
export const createJobMutationError = (
  errorData: {
    errorMessage?: string;
    errorType?: number | string;
    statusCode?: number | string;
    validationErrors?: Array<{ field: string; message: string }>;
  },
  defaultMessage: string
): JobMutationError => {
  const error = new Error(errorData?.errorMessage || defaultMessage) as JobMutationError;

  if (errorData?.validationErrors && errorData.validationErrors.length > 0) {
    error.validationErrors = errorData.validationErrors;
  }

  error.errorType = errorData?.errorType;
  error.statusCode = errorData?.statusCode;
  error.errorMessage = errorData?.errorMessage;

  return error;
};
